import { memo, useMemo } from 'react';
import useRetailCollections from '../Hooks/useRetailCollections';
import useHelpers from '../Hooks/useHelpers';
import useTarifs from '../Hooks/useTarifs';
import useSales from '../Hooks/useSales';
import usePrefStore from '../stores/prefs';
import styles from './CardRetailModel.module.scss';
import DynImage from './DynImage';
import { faStars } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CardRetailModel = memo(function CardRetailModel(props: { id: string; onClick?: (id: string) => void; inactive?: boolean; small?: boolean }) {
   const { getRetailModelById, isExcluBoutique } = useRetailCollections();
   const { getMinMaxCessPriceForModel } = useTarifs();
   const { formatCESPrice, formatRetailPrice } = useHelpers();
   const { getCustomerById } = useSales();
   const curCustomer = usePrefStore((s) => s.curCustomer);
   const customer = useMemo(() => curCustomer ? getCustomerById(curCustomer) : null, [curCustomer, getCustomerById]);

   const model = useMemo(() => getRetailModelById(props.id), [getRetailModelById, props.id])

   const minMaxCession = useMemo(() => {
      const mm = getMinMaxCessPriceForModel(model?.id)
      return mm.reason ? { min: 0, max: 0 } : mm
   }, [getMinMaxCessPriceForModel, model?.id])

   const addClasses = `${props.inactive ? ' ' + styles.inactive : ''}${props.small ? ' ' + styles.small : ''}`

   return (
      <button
         className={`${styles.card_model}${addClasses}`}
         onClick={() => props.onClick?.(props.id)}
      >
         {model && (
            <DynImage
               className={styles.imgmodel}
               src={[`catalogue/ecrins/${model.id}.jpg`, model.bymessika ? model.bymessika[0] : null]}
               alt={`Model ${model.id}`}
            />
         )}
         {model && isExcluBoutique(model) &&
            <span className={`${styles.stars}${addClasses}`}>
               <FontAwesomeIcon icon={faStars} />
            </span>}
         <div>
            <span>
               {model?.id} - {model?.label}
            </span>
            {model && <span>{formatRetailPrice(model, formatCESPrice(minMaxCession.min), customer)}</span>}
         </div>
      </button>
   );
})

export default CardRetailModel;
